import env from '@/env';
import PeachIframe from './index';

export default [
  {
    path: '/',
    title: '桃花岛',
    menuCode: '006-4',
    component: () => <PeachIframe src={env.PEACH_BLOSSOM.MAIN} />,
    hideInNav: true,
  },
  {
    path: '/leoAuto',
    title: '配置营销策略',
    menuCode: '006-4',
    component: () => <PeachIframe src={env.PEACH_BLOSSOM.LEO_AUTO} />,
    hideInNav: true,
  },
  {
    path: '/dmPage',
    title: '诊断分析&调优',
    menuCode: '006-4',
    component: () => <PeachIframe src={env.PEACH_BLOSSOM.DM_PAGE} />,
    hideInNav: true,
  },
];
